"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasSupplierServiceCategoryAdminRole = exports.isUserSupplierServiceCategoryAdmin = exports.hasCommsAdminRole = exports.isUserCommsAdmin = exports.hasSupplierSiteOrderManagerRole = exports.isUserSupplierSiteOrderManager = exports.hasUserSupplierEditorRoleBySupplierId = exports.hasSupplierEditorRole = exports.isUserSupplierEditor = exports.hasUserSupplierAdminRoleBySupplierId = exports.hasSupplierAdminRole = exports.isUserSupplierAdmin = exports.hasSuperAdminRole = exports.isUserSuperAdmin = exports.hasCustomerRepRole = exports.isUserCustomerRep = exports.hasOrgAdminRole = exports.isUserOrgAdmin = exports.hasCustomerRole = exports.isUserCustomer = exports.hasAdminRole = exports.isUserAdmin = exports.getAllUserRoles = exports.UserRoles = void 0;
var auth_1 = require("@aws-amplify/auth");
var UserRoles;
(function (UserRoles) {
    UserRoles[UserRoles["Admin"] = 1] = "Admin";
    UserRoles[UserRoles["Customer"] = 2] = "Customer";
    UserRoles[UserRoles["OrgAdmin"] = 3] = "OrgAdmin";
    UserRoles[UserRoles["SupplierEditor"] = 4] = "SupplierEditor";
    UserRoles[UserRoles["CustomerRep"] = 16] = "CustomerRep";
    UserRoles[UserRoles["SuperAdmin"] = 23] = "SuperAdmin";
    UserRoles[UserRoles["SupplierAdmin"] = 25] = "SupplierAdmin";
    UserRoles[UserRoles["SupplierSiteOrderManager"] = 27] = "SupplierSiteOrderManager";
    UserRoles[UserRoles["CommsAdmin"] = 29] = "CommsAdmin";
    UserRoles[UserRoles["SupplierServiceCategoryAdmin"] = 30] = "SupplierServiceCategoryAdmin";
})(UserRoles || (exports.UserRoles = UserRoles = {}));
var getUserRoles = function () { return __awaiter(void 0, void 0, void 0, function () {
    var currentSession;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 1:
                currentSession = _a.sent();
                return [2 /*return*/, JSON.parse(currentSession.getIdToken().payload['custom:roles'])];
        }
    });
}); };
var userHasRole = function (roleId) { return __awaiter(void 0, void 0, void 0, function () {
    var hasRole, roles;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                hasRole = false;
                return [4 /*yield*/, getUserRoles()];
            case 1:
                roles = _a.sent();
                roles.map(function (role) {
                    if (role.hasOwnProperty(roleId)) {
                        hasRole = true;
                    }
                });
                return [2 /*return*/, hasRole];
        }
    });
}); };
var findRoleInRolesList = function (roles, roleId) {
    var hasRole = false;
    if (!roles) {
        return false;
    }
    roles.map(function (role) {
        if (role.hasOwnProperty(roleId)) {
            hasRole = true;
        }
    });
    return hasRole;
};
var findRoleWithRefIdInRolesList = function (roles, roleId, roleReferenceId) {
    var hasRole = false;
    if (!roles) {
        return false;
    }
    roles.map(function (role) {
        if (role.hasOwnProperty(roleId) && role[roleId] === roleReferenceId) {
            hasRole = true;
        }
    });
    return hasRole;
};
var setStateByRole = function (setStateCallBack, roleId) {
    userHasRole(roleId).then(function (value) {
        setStateCallBack(value);
    });
};
var getAllUserRoles = function (setStateCallBack) {
    getUserRoles().then(function (roles) {
        setStateCallBack(roles);
    });
};
exports.getAllUserRoles = getAllUserRoles;
var isUserAdmin = function (setStateCallBack) {
    setStateByRole(setStateCallBack, UserRoles.Admin);
};
exports.isUserAdmin = isUserAdmin;
var hasAdminRole = function (roles) {
    return findRoleInRolesList(roles, UserRoles.Admin);
};
exports.hasAdminRole = hasAdminRole;
var isUserCustomer = function (setStateCallBack) {
    setStateByRole(setStateCallBack, UserRoles.Customer);
};
exports.isUserCustomer = isUserCustomer;
var hasCustomerRole = function (roles) {
    return findRoleInRolesList(roles, UserRoles.Customer);
};
exports.hasCustomerRole = hasCustomerRole;
var isUserOrgAdmin = function (setStateCallBack) {
    setStateByRole(setStateCallBack, UserRoles.OrgAdmin);
};
exports.isUserOrgAdmin = isUserOrgAdmin;
var hasOrgAdminRole = function (roles) {
    return findRoleInRolesList(roles, UserRoles.OrgAdmin);
};
exports.hasOrgAdminRole = hasOrgAdminRole;
var isUserCustomerRep = function (setStateCallBack) {
    setStateByRole(setStateCallBack, UserRoles.CustomerRep);
};
exports.isUserCustomerRep = isUserCustomerRep;
var hasCustomerRepRole = function (roles) {
    return findRoleInRolesList(roles, UserRoles.CustomerRep);
};
exports.hasCustomerRepRole = hasCustomerRepRole;
var isUserSuperAdmin = function (setStateCallBack) {
    setStateByRole(setStateCallBack, UserRoles.SuperAdmin);
};
exports.isUserSuperAdmin = isUserSuperAdmin;
var hasSuperAdminRole = function (roles) {
    return findRoleInRolesList(roles, UserRoles.SuperAdmin);
};
exports.hasSuperAdminRole = hasSuperAdminRole;
var isUserSupplierAdmin = function (setStateCallBack) {
    setStateByRole(setStateCallBack, UserRoles.SupplierAdmin);
};
exports.isUserSupplierAdmin = isUserSupplierAdmin;
var hasSupplierAdminRole = function (roles) {
    return findRoleInRolesList(roles, UserRoles.SupplierAdmin);
};
exports.hasSupplierAdminRole = hasSupplierAdminRole;
var hasUserSupplierAdminRoleBySupplierId = function (roles, supplierId) {
    return findRoleWithRefIdInRolesList(roles, UserRoles.SupplierAdmin, supplierId);
};
exports.hasUserSupplierAdminRoleBySupplierId = hasUserSupplierAdminRoleBySupplierId;
var isUserSupplierEditor = function (setStateCallBack) {
    setStateByRole(setStateCallBack, UserRoles.SupplierEditor);
};
exports.isUserSupplierEditor = isUserSupplierEditor;
var hasSupplierEditorRole = function (roles) {
    return findRoleInRolesList(roles, UserRoles.SupplierEditor);
};
exports.hasSupplierEditorRole = hasSupplierEditorRole;
var hasUserSupplierEditorRoleBySupplierId = function (roles, supplierId) {
    return findRoleWithRefIdInRolesList(roles, UserRoles.SupplierEditor, supplierId);
};
exports.hasUserSupplierEditorRoleBySupplierId = hasUserSupplierEditorRoleBySupplierId;
var isUserSupplierSiteOrderManager = function (setStateCallBack) {
    setStateByRole(setStateCallBack, UserRoles.SupplierSiteOrderManager);
};
exports.isUserSupplierSiteOrderManager = isUserSupplierSiteOrderManager;
var hasSupplierSiteOrderManagerRole = function (roles) {
    return findRoleInRolesList(roles, UserRoles.SupplierSiteOrderManager);
};
exports.hasSupplierSiteOrderManagerRole = hasSupplierSiteOrderManagerRole;
var isUserCommsAdmin = function (setStateCallBack) {
    setStateByRole(setStateCallBack, UserRoles.CommsAdmin);
};
exports.isUserCommsAdmin = isUserCommsAdmin;
var hasCommsAdminRole = function (roles) {
    return findRoleInRolesList(roles, UserRoles.CommsAdmin);
};
exports.hasCommsAdminRole = hasCommsAdminRole;
var isUserSupplierServiceCategoryAdmin = function (setStateCallBack) {
    setStateByRole(setStateCallBack, UserRoles.SupplierServiceCategoryAdmin);
};
exports.isUserSupplierServiceCategoryAdmin = isUserSupplierServiceCategoryAdmin;
var hasSupplierServiceCategoryAdminRole = function (roles) {
    return findRoleInRolesList(roles, UserRoles.SupplierServiceCategoryAdmin);
};
exports.hasSupplierServiceCategoryAdminRole = hasSupplierServiceCategoryAdminRole;
//# sourceMappingURL=UserRoles.js.map